/**
 * Single Project Header Block JavaScript
 */

(function ($) {
  "use strict";

  // Initialize Slick slider for gallery
  function initSlickSlider() {
    $(".variable-width").slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: false,
      variableWidth: true,
      arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            variableWidth: true,
            arrows: true,
            dots: false,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            variableWidth: true,
            arrows: true,
            dots: true,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            variableWidth: true,
            arrows: false,
            dots: true,
          },
        },
      ],
    });
  }

  // Initialize on DOM ready
  $(document).ready(function () {
    initSlickSlider();
  });
})(jQuery);
